import { navLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-fill text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-900">
                四虎影视大全
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              四虎影视大全是一个专注为广大影迷提供优质观影体验的在线影视平台。海量高清电影免费观看，每日更新不断，打开即看，畅享电影盛宴。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="首页">
                <i className="ri-home-4-line text-sm"></i>
              </a>
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="联系我们">
                <i className="ri-mail-line text-sm"></i>
              </a>
              <a href="#faq" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="常见问答">
                <i className="ri-question-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li><a href="#cards" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">动作大片</a></li>
              <li><a href="#cards" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">悬疑烧脑</a></li>
              <li><a href="#cards" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">喜剧合集</a></li>
              <li><a href="#cards" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">科幻巨制</a></li>
              <li><a href="#cards" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">动画世界</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              感谢所有合作伙伴的支持与信任。如有合作意向，欢迎通过联系方式与我们取得联系。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 四虎影视大全. 本站所有资源仅供学习交流，请于下载后24小时内删除。
          </p>
          <p className="text-xs text-foreground-500">
            四虎影视大全电影大全 · 四虎影视电影免费观看 · 最新大片高清在线
          </p>
        </div>
      </div>
    </footer>
  );
}